<template>
    <div class="modal" v-if="category">
        <div class="modal-container">
            <div class="modal-header">
                <h1>Edit Category</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="category-body">
                        <form class="profile-form">
                            <div class="form-field">
                                <input type="text" v-model="category.name">
                                <label>Name</label>
                            </div>

                            <template v-if="articles">
                                <div class="results-row" v-for="(article, index) in articles" :key="index">
                                    <div class="results-cell" data-width="10%">{{ article.id }}</div>
                                    <div class="results-cell" data-width="50%">{{ article.title }}</div>
                                    <div class="results-cell" data-width="20%">
                                        <button class="btn-primary muted text-center" type="button"
                                                @click="handleViewArticle(article)">View
                                        </button>
                                    </div>
                                </div>
                            </template>
                        </form>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">
                        <button class="btn-danger muted" type="button" @click="handleDelete" v-if="category">Delete
                        </button>
                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                        <button class="btn-primary" type="button" @click="saveForm">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FAQCategoriesView',
    props: {
        //
    },
    data() {
        return {
            category: null,
            articles: null
        }
    },
    components: {
        //
    },
    computed: {
        //
    },
    mounted() {
        this.loadData()

        this.setMetaTitle('View FAQ Category | JournoLink Control')
    },
    beforeRouteUpdate(to, from, next) {
        this.$route.params.categoryId = to.params.categoryId
        this.loadData()
        next()
    },
    beforeDestroy() {
        //
    },
    methods: {
        getCategory() {
            return axios.get(route('faq.categories.show', this.$route.params.categoryId))
        },
        getArticles() {
            return axios.get(route('faq.list', this.$route.params.categoryId))
        },
        loadData() {
            axios.all([this.getCategory()])
                .then(axios.spread((responseCategory) => {
                    this.category = responseCategory.data.category
                }))
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.setMetaTitle('List FAQ Categories | JournoLink Control')
            this.$root.goBack()
        },
        /**
         *
         */
        saveForm() {
            axios.put(route('faq.categories.update', this.$route.params.categoryId), this.category)
                .then(response => {
                    this.category = response.data.category
                    this.$bus.$emit('alert.success', 'Category has been saved')
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        handleViewArticle(article) {
            this.$router.push({name: 'faq.show', params: {faqId: article.id}})
        },
        /**
         * Handle a button-press to delete the Category
         *
         * @return {Object}
         */
        handleDelete() {
            this.alert.fire({
                title: 'Are you sure?',
                text: 'Are you sure you wish to delete this Category? This action will also delete all of the Articles within the Category',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, continue',
                confirmButtonColor: '#E3342F',
                cancelButtonText: 'No, go back'
            })
                .then((selected) => {
                    if (selected.value) {
                        axios.delete(route('faq.categories.delete', this.category.id))
                            .then(response => {
                                this.$bus.$emit('alert.success', 'Category has been deleted')
                                this.$router.push({name: 'faq.categories.list'})
                            })
                            .catch((e) => {
                                console.dir(e)
                            })
                    }
                })
        },
    },
}
</script>

<style lang="less">
.category-body {
    flex: 1;
    padding: 15px;

    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;

        li {
            padding: 5px 0;
        }
    }
}
</style>
